import { FC, Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import TopBarProgress from 'react-topbar-progress-indicator';
import { MasterLayout } from '../../_metronic/layout/MasterLayout';
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils';
import { WithChildren } from '../../_metronic/helpers';
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper';
import ChangePassword from '../modules/auth/components/ChangePassword';

/* Feature modules are split into their own chunks so the initial bundle only
   carries the shell, auth and whichever module the user actually navigates to. */
const AccountingRoutes = lazy(() => import('../modules/accounting/AccountingRoutes'));
const CatalogRoutes = lazy(() => import('../modules/catalog/CatalogRoutes'));
const PurchaseRoutes = lazy(() => import('../modules/purchases/PurchaseRoutes'));
const RDMRoutes = lazy(() => import('../modules/rdm/RDMRoutes'));
const ReportRoutes = lazy(() => import('../modules/reports/ReportsRoutes'));
const SalesRoutes = lazy(() => import('../modules/sales/SalesRoutes'));
const SettingRoutes = lazy(() => import('../modules/settings/SettingRoutes'));
const WorKOrderRoutes = lazy(() => import('../modules/workorder/WorKOrderRoutes'));

const PrivateRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='change-password' element={<ChangePassword />} />
        {/* Lazy Modules */}

        <Route
          path='/catalog/*'
          element={
            <SuspensedView>
              <CatalogRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='/sales/*'
          element={
            <SuspensedView>
              <SalesRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='/workorder/*'
          element={
            <SuspensedView>
              <WorKOrderRoutes />
            </SuspensedView>
          }
        />

        <Route
          path='/reports/*'
          element={
            <SuspensedView>
              <ReportRoutes />
            </SuspensedView>
          }
        />

        <Route
          path='/settings/*'
          element={
            <SuspensedView>
              <SettingRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='/rdm/*'
          element={
            <SuspensedView>
              <RDMRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='purchase/*'
          element={
            <SuspensedView>
              <PurchaseRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='accounting/*'
          element={
            <SuspensedView>
              <AccountingRoutes />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary');
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });

  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
